import { all, takeLatest } from 'redux-saga/effects';

import {
  addPlayerToClassAction,
  createClassAction,
  deleteClassAction,
  getClassAction,
  getClassesAction,
  removePlayerFromClassAction,
  updateClassAction,
} from '@/redux/actions';

import { addPlayerToClassSaga } from './add-player-to-class';
import { createClassSaga } from './create-class';
import { deleteClassSaga } from './delete-class';
import { getClassSaga } from './get-class';
import { getClassesSaga } from './get-classes';
import { removePlayerFromClassSaga } from './remove-player-from-class';
import { updateClassSaga } from './update-class';

export default function* root(): Generator {
  yield all([
    takeLatest(addPlayerToClassAction.request.type, addPlayerToClassSaga),
    takeLatest(createClassAction.request.type, createClassSaga),
    takeLatest(deleteClassAction.request.type, deleteClassSaga),
    takeLatest(getClassAction.request.type, getClassSaga),
    takeLatest(getClassesAction.request.type, getClassesSaga),
    takeLatest(removePlayerFromClassAction.request.type, removePlayerFromClassSaga),
    takeLatest(updateClassAction.request.type, updateClassSaga),
  ]);
}
